const metricSort = (a, b) => {
  if (!a.value && !b.value) {
    return 0;
  } else if (!a.value) {
    return -1;
  } else if (!b.value) {
    return 1;
  } else {
    return a.value - b.value;
  }
};

const locationSort = (a, b) => {
  const nameSort = a.name.localeCompare(b.name)
  if (nameSort === 0) {
    return a.address.localeCompare(b.address)
  } else {
    return nameSort
  }
}

const commonFields = [{
  name: 'OVERALL ACCURACY',
  key: 'overallAccuracy',
  sort: metricSort,
  percent: true,
}, {
  name: 'NAME ACCURACY',
  key: 'nameAccuracy',
  sort: metricSort,
  percent: true,
}, {
  name: 'ADDRESS ACCURACY',
  key: 'addressAccuracy',
  sort: metricSort,
  percent: true,
}, {
  name: 'PHONE ACCURACY',
  key: 'phoneAccuracy',
  sort: metricSort,
  percent: true,
}, {
  name: 'NEW LISTINGS CREATED',
  key: 'newListingsCreated',
  sort: metricSort
}]

export const providerColumns = [{
  name: 'PROVIDER',
  sort: (a, b) => a.localeCompare(b),
  key: 'provider',
}].concat(commonFields)

export const locationColumns = [{
  name: 'LOCATION',
  sort: locationSort,
  key: 'location'
}].concat(commonFields)
